'use strict';

module.exports = function(h, classes, columns) {
    return h(
        'div',
        { class: classes.dropdown.menu + ' dropdown-menu-scale pull-right' },
        [columns],
    );
};



// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vuetable2-checkbox/modules/dropdown-wrapper.jsx